//@ts-ignore
import { formatFloatAsCurrencySymbol } from '../common/helpers.mjs'
//@ts-ignore
import { currencyObject } from '../common/types/types'

import logo from '../images/new_logo.jpg'
import pricequote from '../images/price_quote_darker.png'

// import ContactHeader from './ContactHeader'
import FrontPageData from './FrontPageData'
import FrontPageDisclaimer from './FrontPageDisclaimer'
// import ContractLengthBox from './ContractLengthBox'
import { TermLengthType } from '../types/types'

interface FrontPageProps {
   getString: (key: string, fallback?: string) => string
   ExpirationDate: string
   InvoiceNumber: string
   AccountName: string
   OppContactName: string
   OppContactEmail: string
   RepName: string
   RepEmail: string
   formType: number
   EECount: number
   FirstYearTotal: number
   OnetimeTotalPrice: number
   MonthlyTotalPrice: number
   AnnualTotalPrice: number
   PreviousMonthlyTotal: number
   PreviousAnnualTotal: number
   MonthlyDifference: number
   AnnualDifference: number
   ListPriceTotal: number
   TotalDiscount: number
   DifferenceQuote: boolean
   ActivationDate: string
   prepaymentTerm: string | null
   currencyObject: currencyObject
   currencyObjectUSD: currencyObject
   isForeignCurrencyQuote: boolean
   payrollUsdMonthlyTotal: number
   payrollUsdOneTimeTotal: number
   payrollUsdPreviousMonthlyTotal: number
   payrollUsdMonthlyDifference: number
   payrollUsdPreDiscountTotal: number
   payrollUsdFirstYearSavings: number
   payrollUsdFirstYearTotal: number
   termLengthObject: TermLengthType | null
   HasTimeLimitedDiscount: boolean
   ShowEstimatedCoverage: boolean
   PrepayLength: number
}

function QuoteType({ formType }: { formType: number }) {
   if (formType === 1) {
      return <span className='QuoteType'>Price Quote</span>
   } else if (formType === 4) {
      return <span className='QuoteType'>Order Form</span>
   } else {
      return <></>
   }
}

function DataString({
   formType,
   getString,
   InvoiceNumber,
   ExpirationDate,
}: {
   formType: number
   getString: (key: string, fallback?: string) => string
   InvoiceNumber: string
   ExpirationDate: string
}) {
   const InvoiceString = getString(
      'pdf.frontpage.invoice',
      'PROFORMA INVOICE #',
   )
   const RequestString = getString('pdf.frontpage.request', 'REQUEST #')
   const PreparedString = getString('pdf.frontpage.prepared', 'Prepared')
   const ExpiresString = getString('pdf.frontpage.expires', 'Expires')
   const formatDate = (d: Date) =>
      new Intl.DateTimeFormat('en-US', {
         month: 'long',
         day: 'numeric',
         year: 'numeric',
         timeZone: 'UTC',
      }).format(d)
   const separator = <span className='dataStringSeparator'>|</span>
   if (formType === 1 || formType === 4) {
      return (
         <span>
            {PreparedString} {formatDate(new Date())}
            {separator}
            {ExpiresString}{' '}
            {ExpirationDate ? formatDate(new Date(ExpirationDate)) : 'N/A'}
         </span>
      )
   } else if (formType === 2 || formType === 3) {
      return (
         <span>
            {PreparedString} {formatDate(new Date())}
            {separator}
            {ExpiresString}{' '}
            {ExpirationDate ? formatDate(new Date(ExpirationDate)) : 'N/A'}
            {separator}
            {formType === 2 ? RequestString : InvoiceString} {InvoiceNumber}
         </span>
      )
   } else {
      return <></>
   }
}

export default function FrontPage({
   getString,
   ExpirationDate,
   InvoiceNumber,
   AccountName,
   OppContactName,
   OppContactEmail,
   RepName,
   RepEmail,
   formType,
   EECount,
   FirstYearTotal,
   OnetimeTotalPrice,
   MonthlyTotalPrice,
   AnnualTotalPrice,
   PreviousMonthlyTotal,
   PreviousAnnualTotal,
   MonthlyDifference,
   AnnualDifference,
   ListPriceTotal,
   TotalDiscount,
   DifferenceQuote,
   ActivationDate,
   prepaymentTerm,
   currencyObject,
   currencyObjectUSD,
   isForeignCurrencyQuote,
   payrollUsdMonthlyTotal,
   payrollUsdOneTimeTotal,
   payrollUsdPreviousMonthlyTotal,
   payrollUsdMonthlyDifference,
   payrollUsdPreDiscountTotal,
   payrollUsdFirstYearSavings,
   payrollUsdFirstYearTotal,
   termLengthObject,
   HasTimeLimitedDiscount,
   ShowEstimatedCoverage,
   PrepayLength,
}: FrontPageProps) {
   const TaglineString = getString(
      'pdf.frontpage.tagline',
      'One Easy-to-Use Platform for Everything HR',
   )
   const PrepaymentTermString = getString(
      'pdf.frontpage.prepaymentTerm',
      'Estimated Coverage Period',
   )

   return (
      <div className='frontPage'>
         <div className='frontPageContent'>
            <div className='frontPageIconsAndDates'>
               <div
                  style={{
                     display: 'flex',
                     flexDirection: 'column',
                     alignItems: 'flex-start',
                  }}
               >
                  <QuoteType formType={formType} />
                  <DataString
                     formType={formType}
                     getString={getString}
                     InvoiceNumber={InvoiceNumber}
                     ExpirationDate={ExpirationDate}
                  />
                  {/* {formType > 1 && ShowEstimatedCoverage && (
                     <span>
                        {PrepaymentTermString} {prepaymentTerm}
                     </span>
                  )} */}
               </div>

               {/* <ContractLengthBox termLengthObject={termLengthObject} /> */}

               <div
                  style={{
                     display: 'flex',
                     flexDirection: 'column',
                     alignItems: 'flex-end',
                  }}
               >
                  <img src={logo} height='42' title='logo' />
                  <span style={{ marginTop: '1em' }}>{TaglineString}</span>
               </div>
            </div>
            {/* <ContactHeader
               getString={getString}
               accountName={AccountName}
               bhrEmployeeName={RepName}
               bhrEmployeeEmail={RepEmail}
               clientEmployeeName={OppContactName}
               clientEmployeeEmail={OppContactEmail}
            />
            <hr className='frontPageLine avoid-break-after' /> */}
            <FrontPageData
               getString={getString}
               differenceQuote={DifferenceQuote}
               currencyObject={currencyObject}
               currencyObjectUSD={currencyObjectUSD}
               isForeignCurrencyQuote={isForeignCurrencyQuote}
               payrollUsdMonthlyTotal={payrollUsdMonthlyTotal}
               payrollUsdOneTimeTotal={payrollUsdOneTimeTotal}
               payrollUsdPreviousMonthlyTotal={payrollUsdPreviousMonthlyTotal}
               payrollUsdMonthlyDifference={payrollUsdMonthlyDifference}
               payrollUsdPreDiscountTotal={payrollUsdPreDiscountTotal}
               payrollUsdFirstYearSavings={payrollUsdFirstYearSavings}
               payrollUsdFirstYearTotal={payrollUsdFirstYearTotal}
               employeeCount={EECount}
               firstYearTotal={FirstYearTotal}
               oneTimeFee={OnetimeTotalPrice}
               ongoingMonthlyTotal={MonthlyTotalPrice}
               newAnnualTotal={AnnualTotalPrice}
               previousMonthlyTotal={PreviousMonthlyTotal}
               previousAnnualTotal={PreviousAnnualTotal}
               monthlyDifference={MonthlyDifference}
               annualDifference={AnnualDifference}
               listPriceTotal={ListPriceTotal}
               totalDiscount={TotalDiscount}
               accountName={AccountName}
               clientEmployeeName={OppContactName}
               clientEmployeeEmail={OppContactEmail}
               bhrEmployeeName={RepName}
               bhrEmployeeEmail={RepEmail}
               termLengthObject={termLengthObject}
               activationDate={ActivationDate}
               formType={formType}
               prepayLengthMonths={PrepayLength}
            />
         </div>
         <div className='frontPageBottom'>
            <svg
               className='greenSwoopImage'
               xmlns='http://www.w3.org/2000/svg'
               viewBox='0 0 800 139'
               preserveAspectRatio='none'
               fill='none'
               aria-hidden='true'
            >
               <path
                  d='M-5 0V139H805V0L801.787 0.977335C720.923 25.5781 604.976 60.8517 423 65.6389C238.6 70.4899 45.8333 31.7181 -5 0Z'
                  fill='#EBF5E8'
               />
            </svg>
         </div>
         <FrontPageDisclaimer
            getString={getString}
            showTaxDisclaimer={true}
            showExpiringDiscountDisclaimer={HasTimeLimitedDiscount}
         />
      </div>
   )
}
